exports.APIS = {
  Auth: "/common/auth/service-login",
  ChangePassword: "/common/auth/change-password",

  ServiceAdmin: {
    PickupDropOrders: "/service-center/pickup-drop",
    Notification: "/service-center/notification",
  },

  Transactionhistory: {
    transaction_history: "/service-center/transaction-history",
  },

  ManagePickDropCharges: {
    pick_drop_charges: "/service-center/pick-drop-charges",
  },

  Dashboard: {
    dashboard: "/service-center/dashboard",
  },

  Commons: {
    AllCountry: "/common/master/all-countries",
    AllState: "/common/master/all-states",
    AllCity: "/common/master/all-cities",
    Cities: "/common/master/all-cities",
    AllPincode: "/common/master/all-pincodes",
    AllAccountStatus: "/common/master/all-account-status",
    AllRoles: "/common/master/all-roles",
    AllPermmission: "/common/master/all-permission",
    AllVerificationStatus: "/common/master/all-verification-status",
    AllPickDropStatus: "/common/master/pick-drop-status",
    AllCategory: "/common/master/all-category",
    AllServiceCenter: "/common/master/all-service-center",
    AllServiceType: "/common/master/all-service-type",
    AllTimeSlot: "/common/master/all-time-slots",
    AllSCenterVehicleType: "/common/master/all-s-c-vehicle-types",
    appSetup: "/common/master/get-appsetup",
    tnc: "/common/master/sc-tnc",
  },
};
